<template>
  <div class="top-menu p-d-flex p-jc-between p-ai-center p-p-3">
    <!-- User Info -->
    <div class="user-info">
      <span>{{
        $t("adminToolbar.welcome", { name: globalStore.user.name })
      }}</span>
    </div>

    <!-- Hamburger Menu Button -->
    <div class="ham-menu">
      <Button
        icon="pi pi-bars"
        class="p-button-rounded p-button-text"
        @click="emitMenuClick"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useGlobalStore } from "@/stores/globalStore";

export default defineComponent({
  name: "TopMenu",
  emits: ["menuClick"],
  setup(_, { emit }) {
    const globalStore = useGlobalStore();

    const emitMenuClick = () => {
      emit("menuClick");
    };

    return {
      globalStore,
      emitMenuClick,
    };
  },
});
</script>
